import { render } from "./ExpertStatisticsOriginDetail.vue?vue&type=template&id=5bf39ddc"
import script from "./ExpertStatisticsOriginDetail.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOriginDetail.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOriginDetail.vue?vue&type=style&index=0&id=5bf39ddc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__